import { i as r } from "./index879.mjs";
import { i as n } from "./index880.mjs";
var t = r, s = n;
function o(i) {
  return i != null && s(i.length) && !t(i);
}
var m = o;
export {
  m as i
};
